import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CohortDetailView } from "@/features/academy/components/cohort-detail-view";

function AcademyCohortDetailPage() {
  const params = useParams({ from: "/_app/academy/cohorts/$cohortId" });
  return <CohortDetailView cohortId={params().cohortId} />;
}

export const academyCohortDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/cohorts/$cohortId",
  component: AcademyCohortDetailPage,
});
